const __WEBPACK_NAMESPACE_OBJECT__ = require("next/dist/client/components/static-generation-async-storage.external.js");